import angular from 'angular';
import _ from 'lodash';

import panelWaitSpinnerDirective from './panelWaitSpinner.directive';

export default angular.module('fp:customerportal:common:spinner', [])
    .constant('_', _)
    .directive('fpPanelWaitSpinner', panelWaitSpinnerDirective);